import { MOCK_PATIENT_LEDGER } from 'Data/constants.js'

export function getView() {
  return MOCK_PATIENT_LEDGER ? 'New' : 'Old'
}
